import React from "react";
import { X, RotateCcw } from "lucide-react";
import colors from "../../../colors/colors";
import { Button } from "../../Button";

interface PanelHeaderProps {
  displayName?: string;
  isDirty: boolean;
  isSaving: boolean;
  onReset?: () => void;
  onSave?: () => void;
  onClose: () => void;
  handleMouseDown: (e: React.MouseEvent) => void;
}

export const PanelHeader: React.FC<PanelHeaderProps> = ({
  displayName,
  isDirty,
  isSaving,
  onReset,
  onSave,
  onClose,
  handleMouseDown,
}) => (
  <div
    className="drag-handle"
    onMouseDown={handleMouseDown}
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: `1px solid ${colors.border_glass}`,
      borderRadius: "20px 20px 0 0",
      userSelect: "none",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flex: 1,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "3px",
          opacity: 0.3,
        }}
      >
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            style={{
              width: "4px",
              height: "4px",
              background: colors.gray_medium,
              borderRadius: "1px",
            }}
          />
        ))}
      </div>
      <h3
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: colors.primary,
          margin: 0,
          letterSpacing: "0.2px",
        }}
      >
        {displayName || "Edit Properties"}
      </h3>
    </div>
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      {isDirty && onReset && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          disabled={isSaving}
          aria-label="Reset changes"
          leftIcon={<RotateCcw size={14} />}
        >
          Reset
        </Button>
      )}
      {isDirty && onSave && (
        <Button
          variant="primary"
          size="sm"
          onClick={onSave}
          disabled={isSaving}
          isLoading={isSaving}
          aria-label="Save changes"
          type="submit"
        >
          Save
        </Button>
      )}
      <Button variant="icon" size="md" onClick={onClose} aria-label="Close">
        <X size={18} />
      </Button>
    </div>
  </div>
);
